import {ParkGroup} from "./ParkGroup";
import {User} from "./User";

export class Customer {
  id: number;
  firstSurname: string;
  firstTitle: string;
  secondSurname: string;
  houseName: string;
  companyName: string;
  custName: string;
  address: string;
  contactName: string;
  email: string;
  mobile: string;
  homeTelephone: string;
  workTelephone: string;
  street: string;
  area: string;
  town: string;
  county: string;
  postcode: string;
  invoiceName: string;
  sageAccRef: string;

  fullName: string;

  commissionPercent: number;
  commissionFixed: number;
  allowCommissionOverride: boolean;
  commissionPercentMinimum?: number;
  commissionPercentMaximum?: number;

  discountPercent: number;
  discountFixed: number;
  allowDiscountOverride: boolean;
  discountPercentMinimum?: number;
  discountPercentMaximum?: number;
  upliftPercent: number;
  upliftFixed: number;
  depot: string;

  parkGroupId: string;
  poRequired: boolean;
  sendCustomerCopy: boolean;

  onHold: boolean;
  supplyOnly: boolean;
  depositRequired: boolean;
  depositPercent?: number;

  timberOnly: boolean;
  approvedInstallerRef: string;
  repId: string;

  parkGroup: ParkGroup;
  rep: User;
}
